import { Section } from 'components/section'

import classes from './edge-in-selling.module.css'
import { RightSection } from './right-section'
import { LeftSection } from './left-section'

export const EdgeInSelling = () => {
  return (
    <div className={classes.sectionWrapper}>
      <Section className={classes.section}>
        <LeftSection />
        <RightSection />
      </Section>
    </div>
  )
}
